module Dashboard {
    "use strict";

    export function exampleWidgetDirective(): ng.IDirective {
        return {
            restrict: "EA",
            scope: true,
            bindToController: { config: "=" },
            templateUrl: "exampleWidgetTemplate.htm",
            controller: "ExampleWidgetController as ctrl"
        }
    }
    module.directive("frendsExampleWidget", [exampleWidgetDirective]);

    export class ExampleWidgetController {
        public foo: string;
        public config: ExampleWidgetConfig; // Value assigned by directive bindToController

        public static $inject = ["$http", "$interval", "DashboardConfigService"];
        constructor(private $http: ng.IHttpService, private $interval: ng.IIntervalService, private dashboardConfigService: DashboardConfigService) {
            this.fetch();
            $interval(() => { this.fetch() }, 10000);
        }

        public updateColor() {
            /* Example of updating a widget-specific setting, and persisting the settings. */
            let newColor = (this.config.color === "blue") ? "red" : "blue";
            this.config.color = newColor;
            this.dashboardConfigService.updateWidgetConfig(this.config);
        }
        
        public fetch() {
            /* Here is likely where you will fetch data from the server with the $http service */
        }

        public updateSettingsCallback(config: ExampleWidgetConfig) {
            this.config = config;
            this.fetch();
        }
    }
    module.controller("ExampleWidgetController", ExampleWidgetController);
}